const Shortages = () => {
  return (
    <div>
      <h3>Недостачи</h3>
      <p>Данные о выявленных недостачах.</p>
    </div>
  );
};

export default Shortages;
